import React from 'react';
import UploadList from './UploadList';

const EvidencePanel = ({
  response,
  questionId,
  isLocked,
  onEvidenceChange,
  onFilesSelected,
  onRemoveBackendFile,
  onRetryPendingFile,
  onRemovePendingFile,
  darkMode,
  theme,
}) => {
  return (
    <div
      className={`border rounded-lg p-4 space-y-3 ${
        darkMode ? 'bg-green-900/10 border-green-700' : 'bg-green-50 border-green-300'
      }`}
    >
      <p className={`text-sm font-medium ${darkMode ? 'text-green-300' : 'text-green-900'}`}>
        📝 Evidence Required (Text + Files)
      </p>

      <input
        type="text"
        placeholder="Describe the evidence supporting your answer..."
        value={response.evidence || ''}
        onChange={(e) => onEvidenceChange(questionId, e.target.value)}
        disabled={isLocked}
        className={`w-full border rounded-lg p-2 text-sm focus:outline-none ${
          isLocked ? theme.disabledInput : theme.input
        }`}
      />

      <div
        className={`rounded-lg border px-3 py-3 ${
          darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-300'
        }`}
      >
        <input
          type="file"
          multiple
          onChange={(e) => {
            onFilesSelected(questionId, e.target.files);
            e.target.value = ''; // <-- important: allows reselecting same file and retriggers validation
          }}
          disabled={isLocked}
          className={`w-full text-sm file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:font-semibold ${
            darkMode
              ? 'text-gray-300 file:bg-orange-600 file:text-white hover:file:bg-orange-700'
              : 'text-gray-600 file:bg-orange-100 file:text-orange-800 hover:file:bg-orange-200'
          }`}
        />
        <p className={`mt-2 text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
          Max file size: 150 MB per file.
        </p>
      </div>

      <UploadList
        mode="uploaded"
        files={response.backendFiles || []}
        isLocked={isLocked}
        onRemove={(fileId) => onRemoveBackendFile(questionId, fileId)}
        darkMode={darkMode}
        theme={theme}
      />

      <UploadList
        mode="pending"
        files={response.newFiles || []}
        isLocked={isLocked}
        onRetry={(tempId) => onRetryPendingFile(questionId, tempId)}
        onRemove={(tempId) => onRemovePendingFile(questionId, tempId)}
        darkMode={darkMode}
        theme={theme}
      />
    </div>
  );
};

export default EvidencePanel;